// "Is this mutation running right now?" for both TanStack Query versions.
//
// This app has @tanstack/react-query v4 installed, where a mutation's in-flight flag is
// `isLoading`; `isPending` is the v5 name and is simply `undefined` on v4. Code that read
// `isPending` therefore never saw a request as running, so the submit buttons stayed
// enabled during the request and a second click fired a second (paid) request. Reading
// either name makes the guard work on v4 now and keeps working after an upgrade to v5.
export const isMutationPending = (mutation) =>
  Boolean(mutation?.isPending ?? mutation?.isLoading);
